import React, {Component, Fragment} from 'react';
import {Box, Button, Flex, Heading, Text} from 'rebass';
import {connect} from 'react-redux';
import {searchActions, searchSelectors} from "../../store/search";
import {chatActions} from "../../store/chat";

import {schoolSelectors} from "../../store/school";

import SearchInput from '../../components/Forms/SearchInput'

import {Content, DesktopBox, MobileBox, MobileHeader, PositionBox, Toolbar} from "../../components/Base";

import {AutoFocusInside} from 'react-focus-lock';
import MdCreate from 'react-ionicons/lib/MdCreate'
import MdTrash from 'react-ionicons/lib/MdTrash'
import MdAdd from 'react-ionicons/lib/MdAdd'

import {Action, Fab} from 'react-tiny-fab';
import {ResumeCheckin} from "../../components/Cards";
// import {MetaText} from "../../components/Base/Text";
import UserList from '../../components/UserList'
import Loading from '../../components/Base/Loading'
import {ColumnIcon, GridIcon} from "../../components/Base/Icons";
// import MobileChat from '../Chat/MobileChat'
import Checkin from '../Search/Checkin'
import Share from './Share'
import {withRouter} from "react-router";
import StudentSummary from '../../components/StudentSummary';
import ApplyFilter from '../../components/Search/ApplyFilters'
import FilterDropdown from "../../components/Search/FilterDropdown";
import ConfirmDelete from '../../components/Modals/ConfirmDelete'
import WavePopup from '../../components/Wave/WavePopup'
import '../../resources/css/fab.css';
import {filterStudentsByName} from "../../utils";
import {Chat, Check, Person, SidebarWrapper} from './styles'


class RosterDetails extends Component {

	state = {
		name: '',
		columnView: false,
		detailsView: false,
		currentStudent: null,
		roster: [],
		selected: [],
		allStudents: [],
		rosterStudents: [],
		mobileDetails: false,
		edit: false,
		checkin: false,
		share: false,
		chat: false,
		wave: false,
		confirmDelete: false,
		recentCheckin: null,
		openRecentCheckin: false,
		isLoading: false
	};

	componentDidMount() {
		// this.setState({loading: true})
		const {clearSearch} = this.props;
		clearSearch();
		this.fetchRecentCheckin()
	}

	fetchRecentCheckin = async () => {
		const { isFaculty, firebase, rosterID} = this.props;
		if (isFaculty) {
			try {
				let checkinRef = await firebase.checkins().where('type', '==', 1).where('type_id', '==', rosterID).where('active', '==', true).orderBy('updated_at', 'desc').limit(1).get();
				let result = [];
				checkinRef.docs.forEach(doc => result.push({id: doc.id, ...doc.data()}));
				if (result.length > 0) {
					this.setState({recentCheckin: result[0]})
				}
			} catch (e) {
				console.log("Error saving checkin: ", e)
			}
		}
	};

	handleStudentSelect = async (details, isCheckin = false, selectedItems = []) => {
		const {width, history, roster} = this.props;
		if (isCheckin) {
			this.setState({
				isLoading: true
			})
	
		}
		if (width < 700) {
			history.push(`/app/roster/${roster.id}/${details.id}`)
		} else {
			try {
				let studentRef = this.props.firebase.student(details.id);
				let leavesRef = await this.props.firebase.leaves().where('student_uid', '==', details.id).orderBy('start_date', 'asc').get();
				let leaveResult = [];
				let waveResult = [];
				let waveRef = await studentRef.collection('wave_history').orderBy('post_time').get();
				leavesRef.docs.forEach(doc => leaveResult.push({id: doc.id, ...doc.data()}));
				waveRef.docs.forEach(doc => waveResult.push({id: doc.id, ...doc.data()}));
				details.leaves = leaveResult;
				details.wave = waveResult;

				if (isCheckin) {
					this.setState({
						checkin: false,
						isCheckin: false,
						draftCheckIn: selectedItems,
						currentStudent: details,
						detailsView: true,
						isLoading: false,
						recentCheckin: null
					})
				} else {
					this.setState({
						currentStudent: details,
						detailsView: true
					});
				}
			} catch (err) {
				console.log('failed to fetch student: ', err)
			}
		}


	};

	handleEditSelect = (details) => {
		let {selected} = this.state;
		// console.log('selected for roster', details)
		let contains = false;
		for (var i = selected.length - 1; i >= 0; i--) {
			if (selected[i] === details.id) {
				selected.splice(i, 1);
				contains = true;
				this.setState({selected})
				// break;       //<-- Uncomment  if only the first term has to be removed
			}
		}

		if (!contains) {
			selected.push(details.id);
			this.setState({selected})
		}

	};


	// Sets User list view to grid (table) or column (collection) view
	setPageView = (isColumn) => {
		this.setState({columnView: isColumn})
	};

	// Toggles showing Student Summary
	toggleDetailsView = () => {
		this.setState({detailsView: !this.state.detailsView})
	};

	toggleActionMode = (action) => {
		this.setState({[action]: !this.state[action]})
	};

	// Toggles edit mode to select students in roster
	toggleEditMode = async () => {
		const {edit, rosterStudents} = this.state;
		const {roster, firebase, updateStudents, students} = this.props;
		if (edit === false) {
			try {

				let studentRef = await firebase.students().get();
				let result = [];

				studentRef.docs.forEach(doc => result.push({id: doc.id, ...doc.data()}));
				updateStudents(result);
				this.setState({allStudents: result, rosterStudents: students, selected: roster.students_uid, edit: true})

			} catch (e) {
				console.log('error', e)
			}
		} else {
			updateStudents(rosterStudents);
			this.setState({edit: false,})
		}

	};

	handleSaveEdit = async () => {
		const {selected} = this.state;
		const {roster, firebase, students, updateStudents} = this.props;
		try {

			let rosterRef = await firebase.roster(roster.id);
			let chatRef = await firebase.chat(roster.chat_uid);
			rosterRef.update({
				students_uid: selected
			});
			const chatMembers = [...selected, ...roster.shared_with];
			chatRef.update({
				members: chatMembers
			});
			console.log('chatMembers', chatMembers);
			console.log('selected', selected);
			console.log('shared_with', roster.shared_with);
			updateStudents(students.filter(student => selected.includes(student.id)))
			this.setState({edit: false})
		} catch (e) {
			console.log('error', e)
		}
	};

	// Removes a student from the roster
	handleRemoveStudent = async () => {
		const {currentStudent} = this.state;
		const {roster, firebase} = this.props;
		console.log(roster.students_uid)
		const selected = roster.students_uid.filter(student_uid => student_uid !== currentStudent.id)
		console.log(selected)
		try {

			let rosterRef = await firebase.roster(roster.id);
			let chatRef = await firebase.chat(roster.chat_uid);
			rosterRef.update({
				students_uid: selected
			});
			const chatMembers = [...selected, ...roster.shared_with];
			chatRef.update({
				members: chatMembers
			});
			// updateStudents(students.filter(student => selected.includes(student.id)))
			this.setState({currentStudent: null, detailsView: false})
		} catch (e) {
			console.log('error', e)
		}
	}



	// Checks if chat exists and redirects or creates a new chat and redirects
	handleChatRedirect = async () => {
		const {history, roster, width, updateCurrentChat, firebase} = this.props;
		try {
			let chatID = roster.chat_uid
			let chatRef = await firebase.chat(roster.chat_uid).get()
			// console.log(chatRef.id)
			// console.log(chatRef.data())
			if(chatRef.data() === undefined){
				const members = [roster.creator_uid, ...roster.shared_with, ...roster.students_uid]
				const newRosterChat = await firebase.chats().add({
					creator_uid: roster.creator_uid,
					is_group: true,
					name: roster.name,
					members,
					post_time: Math.floor(Date.now() / 1000),
					last_updated: Math.floor(Date.now() / 1000),
					messages: [],
					accepted: {status: 1, updated_at: Math.floor(Date.now() / 1000), members: members}

				});
				let rosterRef = firebase.roster(roster.id)
				rosterRef.update({
					chat_uid: newRosterChat.id
				})
				chatID = newRosterChat.id
			}
			if (width < 700) {
				history.push(`/app/chat/${chatID}`)

			} else {
				updateCurrentChat(chatID)

				history.push(`/app/chat`)

			}
		} catch(e){
			console.log('chat redirect failed', e)
		}
	};

	handleRosterDelete = async () => {
		const {profile, isFaculty, firebase, roster, history} = this.props;
		if (isFaculty && profile.id === roster.creator_uid) {
			firebase.chat(roster.chat_uid).delete().then(() => console.log('Roster chat deleted succesfully')).catch(error => console.log("Error removing document: ", error));
			firebase.roster(roster.id).delete().then(() => {
				history.replace('/app/roster');
				history.push('/app/roster')
			})
				.catch(error => console.log("Error removing document: ", error))
		}
	};

	handleShareRoster = async (selected) => {
		const {isFaculty, firebase, roster} = this.props;
		if (isFaculty) {
			try {
				let rosterRef = firebase.roster(roster.id);

				rosterRef.update({
					shared_with: selected
				})
			} catch (e) {
				console.log("Error sharing roster: ", e)
			}
		}
	};

	handleWaveStudents = async (location) => {

		const {currentList, profile, isFaculty, updateRoster} = this.props;
		if (isFaculty) {
			try {

				for (let i in currentList) {
					if (!currentList[i].on_leave) {
						let studentRef = this.props.firebase.student(currentList[i].id);
						let waveRef = studentRef.collection('wave_history');

						let newWave = waveRef.doc();
						newWave.set({
							creator_uid: profile.id,
							location_is_geowave: false,
							location_uid: location,
							post_time: Math.floor(Date.now() / 1000)
						});
						studentRef.update({
							current_location: location
						})
					}
				}
				updateRoster()
			} catch (err) {
				console.log(err)
			}
		}
	};

	updateSearch = (e) => {
		const {updateSearch} = this.props;

		updateSearch(e.target.value)
	};

	render() {
		const { columnView, detailsView, edit} = this.state;
		const { roster,  schoolInfo, filters, clearFilter} = this.props;
		let showToolbar = true;
		if (detailsView) {
			showToolbar = false;
		}
		if (columnView) {
			showToolbar = true;
		}
		let count = 0;
		if (roster !== null && roster.students_uid !== undefined) {
			count = roster.students_uid.length
		}
		return (
			<Box>

				{/* MOBILE HEADER */}
				<MobileHeader>
					<Heading pt={2}>{`${roster.name} (${count})`}</Heading>
					<ApplyFilter filters={filters} clearFilter={clearFilter} school={schoolInfo}/>
				</MobileHeader>

				{/* Search Bar */}
				<MobileBox>
					<PositionBox position={'fixed'} top={'24vh'} width={0.98} zIndex={1000}>

						<SearchInput/>
					</PositionBox>

				</MobileBox>
				{/*<FocusLock>*/}

				<Content>

					{this.renderFabButton()}

					<Box ml={[0, '50%', '70%']}>

					</Box>

					<DesktopBox>
						{showToolbar &&
						<Toolbar p={2} bg={'white'} boxShadow={['none', 'main']}>

							<Box css={{display: 'inline-block'}} ml={5}><Text fontSize={0} fontWeight={700} py={2} mt={'3px'}
							                                                  color={'meta'}>VIEW</Text></Box>
							<Box bg={'transparent'} ml={3} py={2} onClick={() => this.setState({columnView: false})}>
								<GridIcon color={!columnView ? 'black' : '#969a9b'}/>
							</Box>
							<Box ml={2} py={2} onClick={() => this.setState({columnView: true})}>
								<ColumnIcon color={columnView ? '#00000' : '#969a9b'}/>
							</Box>

							<Box css={{display: 'inline-block'}} ml={5}><Text fontSize={0} fontWeight={700} py={2} mt={'3px'}
							                                                  color={'meta'}>FILTER</Text></Box>
							<Box ml={3}>
								<FilterDropdown school={schoolInfo} filters={filters} clearFilter={clearFilter}/>
							</Box>


						</Toolbar>
						}
					</DesktopBox>
					{this.renderStudentSummary()}
					{this.renderCheckin()}

					{edit &&
					<PositionBox bg={'white'} position={'fixed'} bottom={0} left={0} width={'100%'} boxShadow={'main'} p={0}
					             m={0}>
						<Flex justifyContent={'center'} p={2}>

							<Button variant={'main'} bg={'green'} onClick={this.handleSaveEdit}>Save</Button>
							<Button variant={'main'} bg={'red'} ml={1} onClick={this.toggleEditMode}>Cancel</Button>
						</Flex>
					</PositionBox>}

				</Content>
				{/*</FocusLock>*/}
			</Box>
		)
	}

	renderStudentSummary = () => {
		const {currentStudent, columnView, detailsView, edit, share, selected, isLoading} = this.state;
		const {students, roster, loading, faculty, profile, search, currentList} = this.props;
		let listProps = {
			width: [1, 1 / 4],
			mt: ['40px', 0],
		};
		if (!columnView) {
			listProps = {
				width: 1,
				mt: ['40px', 3]
			}
		}

		let showUserList = true;
		let showToolbar = true;
		let showDetails = columnView;
		if (detailsView) {
			showToolbar = false;
			showUserList = false;
			showDetails = true
		}
		if (columnView) {
			showToolbar = true;
			showUserList = true;
			showDetails = true
		}
		const showSummary = ( showDetails);

		let searchList = currentList;

		if (search !== null && students.length > 0) {
			// console.log('search', search)
			// console.log('students', students)

			searchList = filterStudentsByName(searchList, search)

		}
		return (
			<Fragment>
				{(loading || isLoading) ? <Loading/> :

					<Flex width={1}>
						{showUserList &&
						<Box {...listProps}>
							<SidebarWrapper boxShadow={['none', columnView ? 'inset' : 'none']} pb={[50, 0]} pt={[0, '10px']}>
								{edit ? <UserList students={searchList} handleUserClick={this.handleEditSelect} withLocation
								                  columnView={columnView} selected={selected}/> :

									<UserList students={searchList} handleUserClick={this.handleStudentSelect} withLocation
									          columnView={columnView} current={currentStudent ? currentStudent.id : '1'}/>}
							</SidebarWrapper>
						</Box>}
						{showSummary ?

							<StudentSummary student={currentStudent} showBack={!showToolbar}
							                handleBack={() => this.setState({detailsView: false})} profile={profile} rosterView handleRemove={this.handleRemoveStudent}/>
							: <Box/>
						}

						<Share visible={share} roster={roster} handleSave={this.handleShareRoster}
						       toggleVisible={() => this.setState({share: false})} faculty={faculty} profile={profile}/>


					</Flex>}
			</Fragment>
		)
	}

	handleSaveCheckin = async (selected, log = '', all) => {
		const {profile, isFaculty, firebase, roster, filters} = this.props;
		if (isFaculty) {
			try {
				// let facultyRef = firebase.faculty(profile.id);
				let newCheckinRef = firebase.checkins().doc();

				newCheckinRef.set({
					creator_uid: profile.id,
					is_faculty: isFaculty,
					all,
					present: selected,
					type: 1,
					type_id: roster.id,
					filters,
					duty_log: log,
					active: true,
					live: false,
					created_at: Math.floor(Date.now() / 1000),
					updated_at: Math.floor(Date.now() / 1000)
				})
				let newCheckin = await newCheckinRef.get();
				const data = {id: newCheckin.id, ...newCheckin.data()}
				// console.log(data)
				this.setState({recentCheckin: data})
				return newCheckin.id

			} catch (e) {
				console.log("Error saving checkin: ", e)
			}
		}
		// console.log(this.state)
	};

	handleUpdateCheckin = async (selected) => {
		const {isFaculty, firebase} = this.props;

		const {recentCheckin} = this.state;
		if (isFaculty) {
			try {
				let checkinRef = firebase.checkins().doc(recentCheckin.id);


				checkinRef.update({
					present: selected,
					updated_at: Math.floor(Date.now() / 1000)
				});
				let newCheckin = await checkinRef.get();
				this.setState({recentCheckin: {id: newCheckin.id, ...newCheckin.data()}})
			} catch (e) {
				console.log("Error saving checkin: ", e)
			}
		}
	};

	handleCheckinDiscard = () => {
		// const {clearFilter} = this.props;
		// clearFilter()
		this.setState({recentCheckin: null})

	};

	toggleRecentCheckin = () => {
		const {recentCheckin, openRecentCheckin} = this.state;
		if (openRecentCheckin === false) {
			if (recentCheckin && recentCheckin.filters) {
				// updateFilter(recentCheckin.filters)
				this.setState({openRecentCheckin: true})
			}
		} else {
			this.setState({openRecentCheckin: false})
		}
	}


	renderCheckin = () => {
		const { recentCheckin, openRecentCheckin, checkin, edit, isCheckin, draftCheckIn, isLoading} = this.state;
		const { roster, currentList} = this.props;

		let recentStudents = []
		if(recentCheckin !== null && recentCheckin.all){
			recentStudents = currentList.filter(student => recentCheckin.all.includes(student.id))
		}
		return (
			<Fragment>
				{recentCheckin !== null && edit === false &&
					<ResumeCheckin toggleRecentCheckin={this.toggleRecentCheckin} checkin={recentCheckin}/>

				}
				{(checkin && !isLoading) &&
				<Checkin visible={checkin} handleSave={this.handleSaveCheckin} handleDiscard={this.handleCheckinDiscard}
						 toggleVisible={() => this.setState({checkin: false})} students={currentList}
						 handleSelectStudent={this.handleStudentSelect}
						 draftSelected={isCheckin ? draftCheckIn : []}
				         title={roster.name}/>
				}
				{recentCheckin !== null && openRecentCheckin &&
				<Checkin visible={openRecentCheckin} handleSave={this.handleUpdateCheckin}
						 handleDiscard={this.handleCheckinDiscard}
						 handleSelectStudent={this.handleStudentSelect}
						 draftSelected={isCheckin ? draftCheckIn : []}
				         toggleVisible={() => this.setState({openRecentCheckin: false})} students={recentStudents}
				         previous={recentCheckin} title={`${roster.name}`}/>}
			</Fragment>
		)

	}

	renderFabButton = () => {
		const { columnView, detailsView, edit, wave, confirmDelete } = this.state;
		const { roster, profile } = this.props;

		let owner = false;
		if (profile && profile.id) {
			if (profile.id === roster.creator_uid) {
				owner = true
			}
		}


		let showDetails = columnView;
		if (detailsView) {

			showDetails = true
		}
		if (columnView) {

			showDetails = true
		}
		const showSummary = ( showDetails);

		let showFab = true
		if(!columnView && showSummary){
			showFab = false
		}
		return (
			<Fragment>
				{!edit && showFab &&
				<Fragment>

					{owner ?
						<Fragment>
							<Fab
								mainButtonStyles={{marginBottom: '22px', backgroundColor: '#FFC61A', width: '47px', height: '47px'}}
								icon={<AutoFocusInside><MdAdd color={'white'}/> </AutoFocusInside>
								}
								event={'click'}
								actionButtonStyles={{color: 'black'}}
							>

								<Action
									text='Edit'
									onClick={this.toggleEditMode}
								>
									<MdCreate color={'white'}/>
								</Action>
								<Action
									text='Delete'
									onClick={() => this.setState({confirmDelete: true})}
								>
									<MdTrash color={'white'}/>
								</Action>

								
								<Action
									text='Share'
									onClick={() => this.setState({share: true})}

								>
									<Person/>
								</Action>
								<Action
									text='Check In'
									onClick={() => this.setState({checkin: true})}

								>
									<Check/>
								</Action>
								<Action
									text='Chat'
									onClick={this.handleChatRedirect}

								>
									<Chat/>
								</Action>
							</Fab>
							<ConfirmDelete visible={confirmDelete} toggle={() => this.setState({confirmDelete: false})}
							               handleConfirm={this.handleRosterDelete}/>
							<WavePopup visible={wave} toggle={() => this.setState({wave: false})}
							           handleConfirm={this.handleWaveStudents}/>
						</Fragment>
						:
						<Fab
							mainButtonStyles={{marginBottom: '22px', backgroundColor: '#FFC61A', width: '47px', height: '47px'}}
							icon={<AutoFocusInside><MdAdd color={'white'}/> </AutoFocusInside>
							}
							event={'click'}
							actionButtonStyles={{color: 'black'}}
						>


							<Action
								text='Check In'
								onClick={() => this.setState({checkin: true})}

							>
								<Check/>
							</Action>
							<Action
								text='Chat'
								onClick={() => this.setState({chat: !this.state.chat})}

							>
								<Chat/>
							</Action>
						</Fab>}
				</Fragment>
				}
			</Fragment>

		)
	}
}

const mapStateToProps = state => ({
	schoolInfo: schoolSelectors.refreshSchool(state.school),
	search: searchSelectors.refreshSearch(state.search),
	filters: searchSelectors.refreshFilters(state.search),
	students: searchSelectors.refreshCurrentResults(state.search),
	placeholder: searchSelectors.refreshPlaceholder(state.search)
});

const mapDispatchToProps = dispatch => ({
	updateSearch: (term) => {
		dispatch(searchActions.updateSearch(term));
	},
	clearSearch: () => {
		dispatch(searchActions.clearSearch());
	},
	clearFilter: () => {
		dispatch(searchActions.clearFilter());
	},
	updateStudents: (students) => {
		dispatch(searchActions.updateStudents(students))
	},
	updateCurrentChat: (id) => {
		dispatch(chatActions.updateCurrentChat(id))
	}
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RosterDetails))
